var exports = {
  "ES": "MessageRoleOffers.module__offersGrid___QmxLWi",
  "VY": "MessageRoleOffers.module__offerButton___QmxLWi",
  "E5": "MessageRoleOffers.module__offerSelected___QmxLWi",
  "CB": "MessageRoleOffers.module__roleIndicator___QmxLWi",
  "S3": "MessageRoleOffers.module__roleName___QmxLWi",
};

module.exports = exports;
